/** @format */

import ApiService from "../../services/ApiService";
import { isLoading, setError, setSuccessMessage } from "./uxAction";

const basePath = "/admin/api/secured/projects";
// http://proxy-api/web-api/projects/%7Bproject_id%7D/project_gallery/

export function createProject(
  {
    accountId,
    title,
    description,
    company,
    projectUrl,
    skills,
    categories,
    videoUrl,
    images = [],
    isPublished,
  },
  callback,
) {
  return async (dispatch) => {
    dispatch(isLoading(true));

    const resp = await ApiService.invokePost(
      process.env.REACT_APP_API_URL + basePath,
      {
        accountId,
        title,
        description,
        company,
        projectUrl,
        skills: skills ? skills.map((v) => v.label) : [],
        categories: categories ? categories.map((v) => v.value) : [],
        videoUrl,
        images: images.length > 0 ? images.map((v) => v.img) : [],
        isPublished: isPublished?.value,
      },
    );

    dispatch(isLoading(false));

    if (resp.status >= 400 && resp.data.errors.length > 0) {
      dispatch(setError(resp.data.errors));
    } else {
      callback();
    }
  };
}

export function updateProject(
  {
    projectId,
    accountId,
    title,
    description,
    company,
    projectUrl,
    skills,
    categories,
    videoUrl,
    galleries = [],
    status,
    isFeatured,
    featured,
  },
  callback,
) {
  return async (dispatch) => {
    dispatch(isLoading(true));

    const resp = await ApiService.invokePatch(
      process.env.REACT_APP_API_URL +
        `/proxy-api/admin/api/secured/projects/${projectId}/`,
      {
        accountId,
        title,
        description,
        company,
        projectUrl,
        skills: skills ? skills.map((v) => v.label) : [],
        categories: categories ? categories.map((v) => v.value) : [],
        videoUrl,
        galleries: galleries.length > 0 ? galleries : [],
        status: status.value,
        isFeatured: isFeatured?.value,
        featured,
      },
    );

    dispatch(isLoading(false));

    if (resp.status >= 400 && resp.data.errors.length > 0) {
      dispatch(setError(resp.data.errors));
    } else {
      dispatch(
        setSuccessMessage({
          title: "Success",
          subTitle: "Project has been successfully updated",
        }),
      );

      callback();
    }
  };
}

export function bulkDeleteProject({ projectIds = [] }, callback) {
  return async (dispatch) => {
    try {
      dispatch(isLoading(true));

      const resp = await ApiService.invokeDelete(
        process.env.REACT_APP_API_URL + basePath,
        {
          projectIds,
        },
      );

      dispatch(isLoading(false));
      if (resp.status == 200) {
        dispatch(
          setSuccessMessage({
            title: "Success",
            subTitle: "Item(s) deleted",
          }),
        );
      }

      if (callback) callback();
    } catch (e) {}
  };
}

export function fetchAllProject(
  { query, page = 0, limit = 3, isFeatured, published },
  callback,
) {
  return async (dispatch) => {
    dispatch(isLoading(true));

    const resp = await ApiService.invokeGet(
      process.env.REACT_APP_API_URL +
        `/proxy-api${basePath}/?query=${query}&page=${page}&limit=${limit}${
          published !== null ? `&published=${published}` : ""
        }${isFeatured !== null ? `&isFeatured=${isFeatured}` : ""}`,
    );

    dispatch(isLoading(false));

    if (resp.status == 200) {
      const { data } = resp.data;

      await dispatch({
        type: "FETCH_PROJECT_TABLE",
        payload: data,
      });

      if (callback)
        callback({
          filteredData: data?.filteredData,
          totalFiltered: data?.filteredData?.length,
          total: data?.total,
        });
    }
  };
}

export function getProject({ projectId }, callback) {
  return async (dispatch) => {
    dispatch(isLoading(true));

    const resp = await ApiService.invokeGet(
      process.env.REACT_APP_API_URL + `${basePath}/${projectId}`,
    );

    dispatch(isLoading(false));

    if (resp.status == 200) {
      callback(resp.data.data);
    }
  };
}

export function changeThumbnail(
  { projectId, oldThubmnail, thumbnail, accountId },
  callback,
) {
  console.log(projectId, oldThubmnail, thumbnail);
  return async (dispatch) => {
    dispatch(isLoading(true));

    const resp = await ApiService.invokePost(
      process.env.REACT_APP_API_URL + `${basePath}/${projectId}/thumbnail`,
      {
        oldThubmnail,
        thumbnail,
        accountId,
      },
    );

    dispatch(isLoading(false));

    if (resp.status >= 400 && resp.data.errors.length > 0) {
      dispatch(setError(resp.data.errors));
    } else {
      dispatch(
        setSuccessMessage({
          title: "Success",
          subTitle: "Thumbnail has been successfully updated",
        }),
      );

      callback();
    }
  };
}
